import { Injectable } from "@angular/core";
import { MessageService } from "@progress/kendo-angular-l10n";
import { I18nService } from "./i18nService";

/*
    to override the standard kendo messages find the key of the message you want to override in the kendo component
    -> look for the text that is shown on the website
    -> add the key to the markerhelper file (https://github.com/telerik/kendo-angular-messages/tree/develop/messages)
    -> generate the translation file
    -> add the translation to the translation file (in all languages)
*/
@Injectable()
export class KendoMessageService extends MessageService {
    constructor(protected LanguageService : I18nService) {
        super();   
        this.LanguageService.languageChanged$.subscribe(() => {
            this.notify()
        });      
    }

    public get(key: string): string | undefined {

    var text = this.LanguageService.instant(key);
    if(text.trim().length === 0 || text === key){	
         text = super.get(key);
    }
    return text
  }
}
